import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class LeadAPI {

  static ModelNo = 1;

  static list = (list, success, failure) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    const sorting = list.sorting;
    const body = { filter, page, perPage, sorting };
    
    fetch(Config.app.link + 'api/lead/list', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static count = (list, success, failure) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    const body = { filter: filter, page: page, perPage: perPage };
    
    fetch(Config.app.link + 'api/lead/list/count', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static get = (id, success, failure) => {
    fetch(Config.app.link + 'api/lead/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static history = (id, success, failure) => {
    fetch(Config.app.link + 'api/lead/history/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static saveLead = (lead, success, failure) => {
    fetch(Config.app.link + 'api/lead/add-edit', new Header('POST', lead))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/lead/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static massUpdate = (list, selected, updates, success, failure) => {
    const filter = list.filters;
    const body = { filter: filter, selected, updates };
    
    fetch(Config.app.link + 'api/lead/mass-update', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static massDelete = (list, selected, success, failure) => {
    const filter = list.filters;
    const body = { filter: filter, selected };
    
    fetch(Config.app.link + 'api/lead/mass-delete', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static massEmail = (list, temp, config, success, failure) => {
    const filter = list.filters;
    const body = { filter: filter, temp, config };
    
    fetch(Config.app.link + 'api/lead/mass-email', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static massSMS = (filter, temp, config, success, failure) => {
    const body = { filter, temp, config };
    fetch(Config.app.link + 'api/lead/mass-sms', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static duplicate = (list, success, failure) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    const sorting = list.sorting;
    const body = { filter, page, perPage, sorting };
    
    fetch(Config.app.link + 'api/lead/duplicate', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
  static getFixedLeadReportList = (filter, success, failure) => {
    const body = { filters : filter};
    fetch(Config.app.link + 'api/lead-report/LeadReport', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}

export default LeadAPI;